module.exports = __webpack_public_path__ + "files/4bd160f44ab988534b6cbd9964e1c752.png";